// extracted by mini-css-extract-plugin
module.exports = {"header1":"Header_header1__QOjc6","header2":"Header_header2__17HOf"};